import React from 'react';

import cx from 'classnames';

import SVG from '../atoms/SVG';
import Text from '../nord-ui/Text';
import { IText } from '../nord-ui/Text/interface';

export interface IIconProps extends IText {
  icon?: string;
  iconTitle?: string;
  componentClassName?: string;
  componentProps?: any;
  component?: any;
  textComponent?: any;
}

const TextWithIcon: React.FC<IIconProps> = ({
  icon = '',
  iconTitle,
  children,
  textComponent,
  className = '',
  componentClassName = '',
  componentProps = {},
  component: Component = SVG,
  ...rest
}) => (
  <Text component={textComponent} className={cx('flex items-center', className)} {...rest}>
    <span className="leading-zero flex-shrink-0">
      <Component
        data-testid="icon"
        src={icon}
        title={iconTitle}
        className={cx('mr-2', componentClassName)}
        {...componentProps}
      />
    </span>
    {children}
  </Text>
);

export default TextWithIcon;
